import {AfterViewInit, Component} from '@angular/core';
import * as feather from 'feather-icons';
import {CommonModule} from '@angular/common';
import {RouterLink} from '@angular/router';
import {AboutComponent} from '../../components/about/about.component';
import {BlogComponent} from '../../components/blog/blog.component';
import {TranslateModule} from '@ngx-translate/core';
import {AuthenticationService} from '../../core/services/authentication/authentication.service';

@Component({
  selector: 'app-home',
  imports: [
    CommonModule,
    RouterLink,
    AboutComponent,
    BlogComponent,
    TranslateModule,
  ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent  implements AfterViewInit {

  constructor(
    private readonly authService: AuthenticationService
  ) {

  }

  get isAuthenticated(): boolean {
    return this.authService.isAuthenticated;
  }

  ngAfterViewInit(): void {
    feather.replace();

  }
}
